import { render, staticRenderFns } from "./GiftCardMessage.vue?vue&type=template&id=54054ed8&"
import script from "./GiftCardMessage.vue?vue&type=script&lang=js&"
export * from "./GiftCardMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports